import { APP_INITIALIZER, NgModule, ErrorHandler } from '@angular/core'
import { BrowserModule } from '@angular/platform-browser'
import * as Sentry from '@sentry/angular-ivy'
import { Router } from '@angular/router'

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { HttpClientModule } from '@angular/common/http'

import { SnackBarModule } from './shared/snack-bar/snack-bar.module'

import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'

import { S3urlResolverService } from './services/s3url-resolver.service'
import { ActivatedRoute } from '@angular/router'
import { GlobalErrorHandler } from './services/chunk-error.handler'
import { SENTRY_CONFIG } from './configs/sentry.config'

export function init_app(S3URLResolverService: S3urlResolverService) {
  return () => S3URLResolverService.load()
}

//Sentry configuration service
Sentry.init({
  dsn: SENTRY_CONFIG?.DSN,
  environment: 'production',
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: SENTRY_CONFIG.ALLOW_ORIGIN,
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: SENTRY_CONFIG.TRACES_SAMPLE_RATE,
  replaysSessionSampleRate: SENTRY_CONFIG.REPLAY_SESSION_SAMPLE_RATE,
  replaysOnErrorSampleRate: SENTRY_CONFIG.REPLAY_ON_ERROR_SAMPLE_RATE,
})

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, BrowserAnimationsModule, SnackBarModule, HttpClientModule],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    { provide: Sentry.TraceService, deps: [Router] },
    {
      provide: APP_INITIALIZER,
      useFactory: init_app,
      deps: [S3urlResolverService, Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    const path = window.location.href.split('#/')

    if (window.location.href.includes('#/action')) {
      window.location.href = `${path[0]}${path[1]}`
    }

    if (window.location.href.includes('#/signin')) {
      const path = window.location.href.split('#/')
      window.location.href = `${path[0]}${path[1]}`
    }
  }
}
